<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class="h-outTabs">
        <ejs-tab ref="tabObj" heightAdjustMode="None" :selected='selectTab'>
          <div class="e-tab-header">
            <div>{{$t('Alarm.alarmSocket')}}</div>
            <div>{{$t('Alarm.alarmOper')}}</div>
          </div>
          <div class="e-content">
            <div id="account_tab1" class="h-alarm-100vh-0 ">
              <div class="h100-140 h-scroll">
                <CurrentAlarmSocket ref='alarmSocket' :roleNetMap='roleNetMap' :roleNe='roleNetList' @count='refreshCount' @updataCount='updataCount'></CurrentAlarmSocket>
              </div>
            </div>
            <div id="account_tab2" class="h-alarm-100vh-0 ">
              <AlarmTableButton ref='alarmTableButton' @notice='notice' @isOn='changeIsOn' @keywords='changeKeywords'
                :refreshBtn='true' :exportBtn='true' :syncBtn='true' :separatorLine='true' :confirmBtn='true' :clearBtn='true'
                :showDetailBtn='true' :shieldBtn='true' :filterBtn='true' :subscritionBtn='false' :autoConfirmBtn='true' :keywordsInput='true'></AlarmTableButton>
              <AlarmCount :roleNe='roleNetList' ref='alarmCount'></AlarmCount>
              <div class="h100vh-200 h-scroll">
                 <AlarmTable :roleNetMap='roleNetMap' @count='refreshCount' @updataCount='updataCount' :roleNe='roleNetList' ref='alarmTable'></AlarmTable>
              </div>
            </div>
          </div>
        </ejs-tab>
      </div>
<!--      <AlarmCount :roleNe='roleNetList' ref='alarmCount'></AlarmCount>-->
<!--      <div class="h100-140 h-scroll">-->
<!--        <CurrentAlarmSocket :roleNetMap='roleNetMap' :roleNe='roleNetList' @count='refreshCount' @updataCount='updataCount'></CurrentAlarmSocket>-->
<!--      </div>-->
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import AlarmCount from '../../components/alarmconfig/currentAlarm/CurrentAlarmCount';
import AlarmTableButton from '../../components/alarmconfig/currentAlarm/CurrentAlarmTableButton';
import AlarmTable from '../../components/alarmconfig/currentAlarm/CurrentAlarmTable';
import CurrentAlarmSocket from '../../components/alarmconfig/currentAlarm/CurrentAlarmSocket';

export default {
  name: 'CurrentAlarmPage',
  components: {
    BasicLayout,
    AlarmCount,
    AlarmTableButton,
    AlarmTable,
    CurrentAlarmSocket
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.currentAlarm')}`
      },
      roleNetMap: {},
      roleNetList: []
    };
  },
  methods: {
    selectTab(event) {
      if (event.selectedIndex === 0) {
        this.$refs.alarmSocket.getAlarmListData();
      } else if (event.selectedIndex === 1) {
        this.$refs.alarmCount.getAlarmCount();
        this.$refs.alarmTable.getAlarmListData();
      }
    },
    changeIsOn(args) {
      this.$refs.alarmTable.isOn = args;
    },
    changeKeywords(args) {
      this.$refs.alarmTable.queryConditions.keywords = args;
    },
    refreshCount(args) {
      this.$refs.alarmCount.getAlarmCount(args);
    },
    updataCount(args) {
      this.$refs.alarmCount.addCount(args);
    },
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.alarmTable.queryConditions.conditions = '';
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'conditions':
          this.$refs.alarmTable.conditionsStatus = true;
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'keywords':
          this.$refs.alarmTable.conditionsStatus = false;
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'export':
          this.$refs.alarmTable.exportAlarmListData();
          break;
        case 'sync':
          this.$refs.alarmTable.syncFunc();
          break;
        case 'confirm':
          this.$refs.alarmTable.confirmAlarm();
          break;
        case 'clear':
          this.$refs.alarmTable.clearAlarm();
          break;
        case 'showDetail':
          this.$refs.alarmTable.showDetail();
          break;
        case 'shield':
          this.$refs.alarmTable.shieldAlarm();
          break;
        case 'filter':
          this.$refs.alarmTable.filterFunc();
          break;
        case 'autoConfirm':
          this.$refs.alarmTable.autoConfirmFunc();
          break;
        default:
      }
    }
  },
  beforeMount() {
    const This = this;
    This.roleNetMap = {};
    This.roleNetList = [];
    This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          This.roleNetMap[response.data[i]] = 1;
          This.roleNetList.push(response.data[i]);
        }
      }
    });
  }
};
</script>
